module.exports = __webpack_public_path__ + "media/images/background_home-1440w-a502c02f.jpg";